var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000a3c;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.21,94.54h-116.43c-26.21,0-47.55,21.34-47.55,47.55v115.82c0,26.21,21.34,47.55,47.55,47.55h116.43c26.21,0,47.55-21.34,47.55-47.55v-115.82c0-26.21-21.34-47.55-47.55-47.55Zm-57.91,174.95h-.61c-37.79,0-68.88-31.09-68.88-69.49s31.09-69.49,68.88-69.49h.61c37.79,0,69.49,31.7,69.49,69.49s-31.7,69.49-69.49,69.49Zm68.27-123.13c-8.53,0-14.63-6.71-14.63-14.63s6.1-14.63,14.63-14.63c7.92,0,14.63,6.71,14.63,14.63s-6.71,14.63-14.63,14.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.3,154.28h-.61c-24.99,0-45.72,20.73-45.72,45.72s20.73,46.33,45.72,46.33h.61c24.99,0,45.72-20.73,45.72-46.33s-20.73-45.72-45.72-45.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,0C89.54,0,0,89.54,0,200s89.54,200,200,200,200-89.54,200-200S310.46,0,200,0Zm127.71,258.52c0,37.79-31.09,68.88-68.88,68.88h-117.65c-37.79,0-68.88-31.09-68.88-68.88v-117.04c0-37.79,31.09-68.88,68.88-68.88h117.65c37.79,0,68.88,31.09,68.88,68.88v117.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cc69352c1d2b81fc9c1f51bad1b9fa3e.svg";
export { ForwardRef as ReactComponent };